import { connect } from "react-redux";
import FrequentlyAskedQuestionsComponent from "./FAQs";
import { addNotification } from "@components/Notifications/actions";

const mapStateToProps = (state) => ({
  user: state.authenticationManagement.data,
  isAnonymous: state.authenticationManagement.isAnonymous,
});

const mapDispatchToProps = (dispatch) => ({
  sendErrorNotification: (title, content) =>
    dispatch(addNotification(title, content, "error")),
  sendSuccessNotification: (title, content) =>
    dispatch(addNotification(title, content, "success")),
  sendWarningNotification: (title, content) =>
    dispatch(addNotification(title, content, "warning")),
});

export const FrequentlyAskedQuestions = connect(
  mapStateToProps,
  mapDispatchToProps
)(FrequentlyAskedQuestionsComponent);
